import script from "./FormulaPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulaPanel.vue?vue&type=script&setup=true&lang=js"

import "./FormulaPanel.vue?vue&type=style&index=0&id=7abc7efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7abc7efa"]])

export default __exports__